// extracted by mini-css-extract-plugin
module.exports = {"nav":"TableOfContents_nav__wcKWF"};